<template>
    <layouts-header></layouts-header>
    <layouts-sidebar></layouts-sidebar>
    <div class="page-wrapper">
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <!-- Page Header -->
            <page-header :title="title" />
            <!-- /Page Header -->
  
            <div class="row">
              <leads-details-sidebar 
              :leadId="leadId" 
              :concernPersonInfo="concernPersons" 
              :initialInfo="initialInfo"
              :leadInfo="leadInfo"
              @logoUploaded="getLeadInfo"
              ></leads-details-sidebar>
  
              <div class="col-xl-9 col-lg-12">
                <div class="card">
                  <div class="card-body">
                      <leads-details-section v-if="currentLeadStage" 
                      :leadId="leadId" 
                      :currentLeadStage="currentLeadStage" 
                      :concernPersonInfo="concernPersons"
                      :initialInfo="initialInfo"
                      ></leads-details-section>
                  </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="tab-section d-flex justify-content-between align-items-center">
                          <ul class="nav nav-tabs">
                            <li class="nav-item" v-for="(tab, index) in bottomTabs" :key="index">
                              <button
                                class="nav-link"
                                :class="{ active: currentBottomTab === tab.name }"
                                @click="currentBottomTab = tab.name"
                              >
                                {{ tab.name }}
                                <span v-if="tab.count > 0" class="tab-count">{{ tab.count }}</span>
                              </button>
                            </li>
                          </ul>
                          <button class="btn btn-primary" @click="toggleExpand">
                              {{ expandAll ? 'Collapse All' : 'Expand All' }}
                          </button>
                        </div>

                        <LogDetailsLogList :timelineData="filteredDetails"
                         :currentBottomTab="currentBottomTab"
                         :expandAll="expandAll" 
                         @update-expanded-cards="updateExpandedCards" />
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import http from "@/utils/http";
  import Multiselect from "vue-multiselect";
  import LogDetailsLogList from "../leads/organization/leads-details-log-list.vue";
  
  export default {
    components: {
      Multiselect,
      LogDetailsLogList
    },
    data() {
      return {
        title: "Key Account Details",
        leadId: null,
        currentLeadStage: '',
        leadInfo: {},
        concernPersons: [],
        initialInfo: {},
        bottomTabs: [
          { name: 'All', count: 0 },
          { name: 'Note', count: 0 },
          { name: 'Log Activity', count: 0 },
          { name: 'Task', count: 0 },
          { name: 'SMS', count: 0 },
          { name: 'Email', count: 0 },
          { name: 'File', count: 0 },
        ],
        filteredDetails: [],
        currentBottomTab: "All",
        expandAll: true,
        expandedCards: {},
        allDetails: {},
      };
    },
    watch: {
      "$route.params.id": {
        immediate: true,
        handler(newId) {
          this.leadId = newId;
        },
      },
    },
    computed: {
      filteredDetails() {
        if (this.currentBottomTab === 'All') {
          return this.allDetails;
        }
        return this.allDetails.filter(item => item.type === this.currentBottomTab);
      },
    },
    created() {
      this.fetchTabCountsAndData();

      this.$emitter.on("form-submitted", () => {
        this.fetchTabCountsAndData()
      });
    },
    mounted() {
      this.getLeadInfo();
    },
    methods: {
        async getLeadInfo() {
          const endpoint = `/leads/${this.leadId}`;
          const method = "get";
          try {
            const response = await http[method](endpoint);
            this.currentLeadStage = response.data.contents.lead_stage
            this.concernPersons = response.data.contents.concern_person.concern_person_info
            this.initialInfo = response.data.contents.initial_info
            this.leadInfo = response.data.contents
          } catch (error) {
            //
          }
        },  

        formatDate(date) {
          return new Date(date).toLocaleString();
        },

        async fetchTabCountsAndData() {
            const endpoint = `/get-key-account-details-tab-count`;
            const method = "post";
            let body = {
                lead_id: this.leadId
            };
            try {
                const response = await http[method](endpoint, body);
                const counts = response.data.contents.counts;
                this.allDetails = response.data.contents.details;

                this.bottomTabs = this.bottomTabs.map((tab) => ({
                  ...tab,
                  count: counts[tab.name] || 0,
                }));
            } catch (error) {
            }
        },

        selectTab(tab) {
            this.currentBottomTab = tab;
            this.expandedCards = {};
        },
  
        // toggleExpand() {
        //     this.expandAll = !this.expandAll;
        //     Object.keys(this.allDetails).forEach((_, index) => {
        //         this.expandedCards[index] = this.expandAll;
        //     });
        // },
        toggleExpand() {
          this.expandAll = !this.expandAll;
        },
        updateExpandedCards(updatedCards) {
          console.log("Expanded card states:", updatedCards);
        },

        toggleCard(index) {
          if (!this.expandedCards) {
            this.expandedCards = {};
          }
          this.expandedCards[index] = !this.expandedCards[index];
        },

        async submitForm() {
            this.isLoading = true;
            const endpoint = "/store-leads-initial-info";
            const method = "post";
            let body = {
            organization_name: this.organizationName,
            industry_type: this.industryType.id,
            // interested_item: this.interetedProduct.id,
            information_source_id: this.informationSourceId,
            information_source_text: this.informationSourceQuery,
            phone: this.phone,
            address: this.address,
            zone_id: this.zoneID.id,
            website_link: this.websiteLink,
            exhibitions: this.exhibitions,
            social_networks: this.socialNetworks,
            };
            try {
            const response = await http[method](endpoint, body);
    
            this.$toast.success(response.data.message);
            this.$router.push('/leads-organization/concern-person-info');
            } catch (error) {
            this.errors = error.response.data.errors;
            } finally {
            this.isLoading = false;
            }
        },

    },
  };
  </script>
  <style src="vue-multiselect/dist/vue-multiselect.css"></style>
  
<style scoped>
.details-section {
  margin-top: 20px;
}
.details-card {
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: #f9f9f9;
}
.details-header {
  padding: 10px 15px;
  background: #e9f1ff;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}
.details-body {
  padding: 15px;
}
.details-item {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #ddd;
}
.details-item:last-child {
  border-bottom: none;
}
.details-title {
  font-weight: bold;
  color: #333;
}
.details-info {
  font-size: 14px;
  color: #666;
}

  .tab-section{
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #E3EFFF;
  }

  .tab-section .nav-tabs {
    border-bottom: none;
    margin-bottom: 0;
  }
  
  .nav-item {
    padding: 2px;
  }

  .tab-section .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-radius: 5px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .tab-section .tab-count {
    background-color: #4285F4;
    color: #ffffff;
    font-size: 12px;
    font-weight: bold;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
  }

  .tab-section .nav-tabs .nav-link.active {
    background-color: #4285F4;
    color: #ffffff;
  }

.details-section {
  margin-top: 20px;
}

.tab-details {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: #f9f9f9;
}

.tab-details h4 {
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
}
</style>
